import { sanitizeRedirectPathToUrl } from '@reward-platform/utils'

export const getSanitizedReturnTo = (
  returnTo: string,
  validationBaseUrl: string
): string | undefined => {
  const safeBaseUrl = new URL(validationBaseUrl)
  const sanitizedReturnToUrl = sanitizeRedirectPathToUrl(returnTo, safeBaseUrl)

  if (!sanitizedReturnToUrl) {
    return sanitizedReturnToUrl
  }

  return `${sanitizedReturnToUrl.pathname}${sanitizedReturnToUrl.search ?? ''}`
}
